import axios from 'axios';
import AppConfig from './../.env';
import router from '@/router';

const axiosInstance = axios.create({
  baseURL: AppConfig.apiServerUrl,
  withCredentials: true,
  headers: {
    'Cache-Control': 'no-store,max-age=0'
  }
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      if (router.currentRoute.path !== '/loading') {
        window.location.reload();
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
